import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/config";
import { signOut } from "firebase/auth";

import { IoMdLogOut } from "react-icons/io";
import "../styles/LogoutButton.css"; // shared styles

export default function LogoutButton({ isSidebarOpen, variant = "admin" }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error.message);
    }
  };

  const btnClass = variant === "employee" ? "employee-logout" : "logout-btn";
  const iconClass =
    variant === "employee" ? "employee-logout-icon" : "logout-icon";

  const labelClass =
    variant === "employee" ? "employee-logout-label" : "logout-label";

  return (
    <button className={btnClass} onClick={handleLogout}>
      <IoMdLogOut className={iconClass} />
      {variant === "admin" && isSidebarOpen && (
        <span className={labelClass}>Logout Account</span>
      )}
    </button>
  );
}
